export const CHECKOUT_CARD_CSS = /* css */ `
  .lk-checkout-card {
    width: 100%;
    max-width: 304px;
    border-radius: 14px;
    overflow: hidden;
    background: var(--wg-bg);
    box-shadow: var(--wg-card-shadow);
    margin: 8px 0;
    animation: lk-card-in 0.4s ease backwards;
    transition: transform 0.15s ease-out, box-shadow 0.15s ease-out;
  }
  .lk-checkout-card:hover {
    transform: scale(1.02);
    box-shadow: var(--wg-card-shadow-hover);
  }
  .lk-checkout-card-image {
    height: 180px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #f8f8f8;
  }
  .lk-checkout-card-body {
    padding: 14px 14px 18px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: var(--wg-card-fg);
  }
  .lk-checkout-card-top {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .lk-checkout-card-brand {
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.36px;
    color: var(--wg-fg-muted);
    text-transform: uppercase;
  }
  .lk-checkout-card-name {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
    letter-spacing: -0.32px;
    color: var(--wg-card-fg);
  }
  .lk-checkout-card-variant {
    font-size: 13px;
    font-weight: 400;
    line-height: 1.3;
    letter-spacing: -0.13px;
    color: var(--wg-card-fg-muted);
  }
  .lk-checkout-card-rows {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .lk-checkout-card-row {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    line-height: 1.3;
    font-weight: 400;
    letter-spacing: -0.13px;
    color: var(--wg-card-fg-muted);
  }
  .lk-checkout-card-icon {
    width: 16px;
    height: 16px;
    flex: 0 0 auto;
    color: var(--wg-card-fg-muted);
  }
  .lk-checkout-card-price-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 4px;
    border-top: 1px solid var(--wg-border);
  }
  .lk-checkout-card-total-label {
    font-size: 13px;
    font-weight: 500;
    color: var(--wg-card-fg-muted);
  }
  .lk-checkout-card-total {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.4px;
    color: var(--wg-card-fg);
  }
  .lk-checkout-card-cta {
    display: block;
    padding: 10px 20px;
    background: var(--wg-cta-bg);
    color: var(--wg-fg);
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: -0.13px;
    border-radius: 999px;
    text-align: center;
    text-decoration: none;
  }
  .lk-checkout-card-cta:hover {
    background: var(--wg-cta-bg-hover);
  }
`;
